<template>
  <b-field
    :label="$t('compCoreInstitutionTypeInput.label-1') + ' *'"
    :type="{ 'is-danger': errors.has('type') }"
    :message="errors.first('type')"
  >
    <b-select
      :placeholder="$t('compCoreInstitutionTypeInput.label-2') + ' *'"
      icon="university"
      v-validate="'required'"
      name="type"
      expanded
      :disabled="loading"
      v-model="type"
      @input="inputChanged"
    >
      <option
        v-for="(type, index) in institutionTypes"
        :value="type"
        :key="index"
      >
        {{ type.name }}
      </option>
    </b-select>
  </b-field>
</template>

<script>
import coreService from '@/services/coreService'

export default {
  name: 'InstitutionTypeInput',
  inject: ['$validator'],
  props: {
    value: {
      type: Object,
      default: function () {
        return {
          id: null,
          name: ''
        }
      }
    }
  },
  emits: ['input'],
  data () {
    return {
      loading: true,
      type: this.value,
      institutionTypes: []
    }
  },
  methods: {
    selectTypes (option) {
      if (option) {
        this.type.id = option.id
        this.type.name = option.name
      }
    },
    inputChanged () {
      if (this.loading) {
        // ignore everything while the list of domains isn't fully loaded
        return
      }
      this.$emit('input', this.type)
    }
  },
  watch: {
    value: {
      handler () {
        this.type = this.value
      }
    }
  },
  created () {
    coreService.getInstitutionTypes().then((data) => {
      this.institutionTypes = data
      this.loading = false
    })
  }
}
</script>
